export default {
	FETCH_LINE_TYPES(state, payload) {
		state.lineTypes = payload;
	},
	SET_HAS_ASSIGNED_SEAT_LINE(state, payload) {
		state.hasAssignedSeatLine = payload;
	},
};
